export default "__VITE_ASSET__CuC9akpW__"